import React from 'react';
import { Grid, Radio, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { OrderedQuestion } from '../../../pages/motive-survey';

const RADIO_VALUES = [0, 1, 2, 3, 4, 5];

interface Props {
  question: OrderedQuestion;
  selectedValue: number;
  index: number;
  hasError: boolean;
  selectionChangeHandlerGenerator(shuffledIdx: number, realIdx: number, realType: string): (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Question: React.FC<Props> = ({ question, selectedValue, selectionChangeHandlerGenerator, index, hasError }) => {
  const { classes } = useStyles();

  return (
    <Grid size={12} className={hasError ? classes.questionError : undefined}>
      <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        <Grid size={6} className={classes.questionText}>
          <Typography variant="body1">{question.text}</Typography>
        </Grid>
        {RADIO_VALUES.map((value) => (
          <Grid size={1} key={value} className={classes.radioCell}>
            <Radio
              checked={selectedValue === value}
              onChange={selectionChangeHandlerGenerator(index, question.realCategoryIndex, question.category)}
              value={value}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles()((theme) => ({
  questionText: {
    display: 'flex',
    alignItems: 'center',
  },
  radioCell: {
    textAlign: 'center',
  },
  questionError: {
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.error.light,
    padding: theme.spacing(1),
  },
}));

export default React.memo(Question);
